<template>
  <v-app>
    <v-navigation-drawer
      app
      clipped
      absolute
      hide-overlay
      mobile-breakpoint=""
      v-if="isMobile"
      style="min-height: 555px;"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <iframe style="min-width: 220px;" width="100%" height="210" src="https://www.youtube.com/embed/XrpjJBbNigc?si=qWuJtNWHyJvX7Bv2&mute=1" frameborder="0" allow="encrypted-media" allowfullscreen></iframe>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item
          v-for="item in filteredItems"
          :key="item.title"
          :to="item.href"
          link
          @click="handleReset(item.href)"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-list-item v-if="isLogged" @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>LOGOUT</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list>

      <div style="position: absolute; bottom: 0px; width: 100%;">
        <v-divider></v-divider>
        <v-card-title 
          style="min-height: 30px !important; padding: 0px !important;justify-content: center !important; margin-top: 10px;"
        >
          <a 
            v-for="(icon,index) in icons"
            :href="icon.link"
            v-bind:key="index"
            target="_blank"
            style="width: 50px; display: flex; text-decoration: none; justify-content: center; align-items: center;"
            class="snsBtn"
          >
            <v-hover v-slot="{hover}">
              <v-btn
                class="mx-4"
                icon
                :color="hover ? icon.color : 'rgba(0,0,0,.54)'"
              >
                <v-icon size="24px">
                  {{ icon.icon }}
                </v-icon>
              </v-btn>
            </v-hover>
          </a>
        </v-card-title>
        <div class="pa-0 text-center">info@wikisecurity.net</div>
        <div class="pa-1 text-center text-caption">Don't Miss To Follow Us On Our Social Networks Official Accounts.</div>
      </div>
    </v-navigation-drawer>
    <v-navigation-drawer      
      v-if="!isMobile && drawer"
      v-model="drawer"
      app
      clipped
      temporary
      hide-overlay
      width=""
      mobile-breakpoint=""
      style="min-height: 555px; width: 256px; top: 48px; z-index: 20;"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <iframe style="min-width: 220px;" width="100%" height="210" src="https://www.youtube.com/embed/XrpjJBbNigc?si=qWuJtNWHyJvX7Bv2&amp;mute=1" frameborder="0" allow="encrypted-media" allowfullscreen></iframe>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item
          v-for="item in filteredItems"
          :key="item.title"
          :to="item.href"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-list-item v-if="isLogged" @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>LOGOUT</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list>

      <div style="position: absolute; bottom: 0px; width: 100%;">
        <v-divider></v-divider>
        <v-card-title 
          style="min-height: 30px !important; padding: 0px !important;justify-content: center !important; margin-top: 10px;"
        >
          <a 
            v-for="(icon,index) in icons"
            :href="icon.link"
            v-bind:key="index"
            target="_blank"
            style="width: 50px; display: flex; text-decoration: none; justify-content: center; align-items: center;"
            class="snsBtn"
          >
            <v-hover v-slot="{hover}">
              <v-btn
                class="mx-4"
                icon
                :color="hover ? icon.color : 'rgba(0,0,0,.54)'"
              >
                <v-icon size="24px">
                  {{ icon.icon }}
                </v-icon>
              </v-btn>
            </v-hover>
          </a>
        </v-card-title>
        <div class="pa-0 text-center">info@wikisecurity.net</div>
        <div class="pa-1 text-center text-caption">Don't Miss To Follow Us On Our Social Networks Official Accounts.</div>
      </div>
    </v-navigation-drawer>
    
    <v-app-bar
      app
      color="blue-grey lighten-4"
      dense
      absolute
      elevation="3" 
      light
      id="main-bar"
      style="z-index: 200;"
    >
    <v-tab
    class="home-btn"
    :to="'/'"
    type="button"
    >
      <v-img
          class="mb-1;"
          max-width="69"
          contain
          src="./assets/logo.png"
          style="cursor: pointer;"
        >
      </v-img>
    </v-tab>
      <div class="px-3" style="font-size: 20px; margin-top: 5px; font-weight: bold;" v-if="$vuetify.breakpoint.width>600">Web Vulnerability Scanner</div>
      <div class="px-3" style="font-size: 20px;" v-if="$vuetify.breakpoint.width<=600">WS</div>
      <div v-if="isLogged" style="height: 100%; position: absolute; right: 10px; display: flex; align-items: center; justify-content: center;">
        <div style="text-align: right; margin-right: 5px;">
          <div style="font-size: 18px; font-weight: bold; height: 20px;">
            {{ userData.username }}
          </div>
        </div>
        <div>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <div style="width: 30px; height: 30px;">
                <img src="@/assets/account.svg" v-bind="attrs" v-on="on" />
              </div>
            </template>

            <v-list id="userMenu" class="pa-1">
              <v-card-text v-if="userData.lastLogin!=null" class="text-subtitle-3" style="padding: 10px; font-size: 13px; line-height: 15px;">
                Last Login<br>: {{ userData.lastLogin }}
              </v-card-text>
              <v-card-text v-if="userData.lastLogin==null" class="text-subtitle-3" style="padding: 10px; font-size: 13px; line-height: 15px;">
                First Login
              </v-card-text>
              <!-- <v-card-text  style="padding: 10px; font-size: 13px; line-height: 15px;">
                Validation<br>: {{ userData.check }}
              </v-card-text> -->
              <v-divider></v-divider>
              <v-list-item class="pa-0" dense :to="'/settings'" @click="show=false">
                <v-list-item-icon>
                  <v-icon>mdi-cog</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Settings</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="pa-0" dense @click="logout" v-if="isLogged">
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <v-btn icon small v-if="!isMobile" @click.stop="drawer = !drawer">
          <img src="@/assets/menu.svg">
        </v-btn>
      </div>
      
      <v-btn icon small v-if="!isMobile && !isLogged" @click.stop="drawer = !drawer" style="position: absolute; right: 20px;">
        <img src="@/assets/menu.svg">
      </v-btn>
    </v-app-bar>
    <v-main>
        <router-view :key="viewKey"></router-view>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';
import EventBus from './plugins/EventBus';

export default {
  name: 'App',
  data() {
    return {
      drawer: false,
      icons: [
        {
          icon: 'mdi-facebook',
          link: 'https://www.facebook.com/people/Wiki-Security-INC/100064205460242/',
          color: 'indigo'
        },
        {
          icon: 'mdi-youtube',
          link: 'https://www.youtube.com/channel/UCddHTMigvEFbI8Zu29ODwAQ?view_as=subscriber',
          color: 'red'
        },
        {
          icon: 'mdi-linkedin',
          link: 'https://in.linkedin.com/company/wiki-security',
          color: 'blue'
        },
      ],
      items: [
        { title: 'INTRODUCTION', icon: 'mdi-information', href: '/' },
        { title: 'LOGIN', icon: 'mdi-login', href: '/login', show: true },
        { title: 'SCANNER', icon: 'mdi-video', href: '/scan', show: false }, 
        { title: 'SCAN HISTORY', icon: 'mdi-history', href: '/history', show: false }, 
        { title: 'MANAGEMENT', icon: 'mdi-account', href: '/manage', show: false, permission:true }
      ],
      show: false,
      inactivityTimer: null,
      lastActivityTime: new Date().getTime(),
      logoutTimeout: 3600000,
      localStorageKey: 'lastActivityTime',
      spiderId: null,
      scanId:null,
      result: [],
      timeInterval:null,
      statusInterval:null,
      scanInterval:null,
      timeTaken:null,
      yaraInstance:[],
      sec:0,
      min:0,
      viewKey:0,
      preRoute: null,
      stopWatchFlag: false
    };
  },
  computed: {
    isLogged() {
      return this.$store.state.isLogged;
    },
    userGroup(){
      return this.$store.state.userData.group;
    },
    filteredItems() {
      if (this.isLogged) {
        if(this.userGroup == 'Admin'){
          return this.items.filter(item => item.title !== 'LOGIN');
        }else{
          return this.items.filter(item => item.title !== 'LOGIN' && item.title !=='MANAGEMENT');
        }
      } else {
        return this.items.filter(item => item.show || item.href == '/');
      }
    },
    userData() {
      return this.$store.state.userData;
    },
    isMobile(){
      var display=false;
      switch(this.$vuetify.breakpoint.name){
        case `md`: display=true; break;
        case `lg`: display=true; break;
        case `xl`: display=true; break;
      }
      return display;
    },
    // viewKey(){
    //   if(this.$route.meta.forceRerender && this.$store.state.resetFlag){
    //     console.log("야호")
    //     return `${this.$route.fullPath}-${Date.now()}`;
    //   }
    //   return this.$route.fullPath;
    // }
  },
  methods: {
    handleReset(href){
      // console.log(href)
      if(this.preRoute =='/scan' && href=='/scan' && this.$store.state.resetFlag){
        console.log("야호")
        this.viewKey++;
        this.$store.commit('setCurResult', undefined);
        this.$store.commit('setResetFlag', false);
        localStorage.removeItem("scanResult");
      }
      this.preRoute = this.$route.fullPath;
      console.log(this.preRoute)
    },
    logout() {
      EventBus.$emit('stopScan');
      axios.post(`${this.$apiUrl}/user/logout`, {}, { withCredentials: true })
        .then((res) => {
          if (res.status === 200) {
            this.$store.dispatch('logout').then(() => {
              if (this.$route.path !== '/login') {
                this.$router.push('/login');
              }
            });
          }
        }).catch(error => {
          console.error("Logout error: ", error);
        });
    },
    resetInactivityTimer() {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(() => {
        this.logout();
      }, this.logoutTimeout);
      this.lastActivityTime = new Date().getTime();
      localStorage.setItem(this.localStorageKey, this.lastActivityTime);
    },
    handlePageUnload() {
      localStorage.setItem(this.localStorageKey, new Date().getTime());
    },
    checkForInactivity() {
      const lastActivity = localStorage.getItem(this.localStorageKey);
      if (lastActivity) {
        const timeSinceLastActivity = new Date().getTime() - parseInt(lastActivity);
        if (timeSinceLastActivity >= this.logoutTimeout) {
          this.logout();
        }
      }
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.checkForInactivity();
      }
    },
    startStopWatch: function () {
      this.value=0;
      this.timeInterval = setInterval(() => {
        if (this.sec === 59) {
          this.sec = 0;
          this.min++;
        } else {
          this.sec++;
        }
        this.timeTaken = `${this.min.toString().padStart(2, "0")}:${this.sec.toString().padStart(2, "0")}`;
        this.$store.commit("setTimeTaken", this.timeTaken);
        this.$store.commit("setScanStatus", this.value);
        console.log(this.timeTaken)
      }, 1000);
    },
    stopStopWatch: async function(){
      clearInterval(this.scanInterval);
      clearInterval(this.timeInterval);
      clearInterval(this.statusInterval);
      this.sec=0;
      this.min=0;
      this.stopWatchFlag=false;
      this.resetFlag=true;
      this.$store.commit('setScanStatus', undefined);
      this.$store.commit('setTimeTaken', undefined);
      this.$store.commit('setCurLeft', undefined);
      localStorage.removeItem("timeTaken");
      localStorage.removeItem("scanStatus");
      if(this.scanId){
        const response = await axios.post(`${this.$apiUrl}/webscan/stop`, {}, { withCredentials: true });
        if(response.data.result){
          console.log("success");
        }else{
          console.error("failed to stop scan");
        }
      }else{
        console.error("No scan ID available to stop.")
      }
    },
    showError:function(error){
      EventBus.$emit("showError", error);
    },
    startScan: async function(payload){
      try{
        // this.startStopWatch();
        this.resetFlag = false;
        this.stopWatchFlag = false;
        console.log(payload)
        const res = await axios.post(`${this.$apiUrl}/webscan/start`, payload, { withCredentials: true });
        console.log(res);
        if(res.data.error){
          var message = '';
          var error = res.data.error
          this.stopStopWatch();
          switch(error){
            case "site own validation fail": 
              message = 'Site ownership validation failed. Please check your meta tag.'; 
              break;
            case "session cannot check":
              message = 'Session validation failed. Please check your session.';
              break;
            case "login validation failed":
              message = 'Login validation failed. Please check your login credentials.';
              break;
            case "SPA Auth scan not Supported yet.":
              message = error;
              break;
            case "url not valid":
              message = error;
              break;
            case "Target Site cannot access, Please check URL." :
              message = error;
              break;
          }
          this.showError(message);
        }
        if(res.data.result){
          this.value= 0;
          this.scanId = res.data.scan_id;
          this.statusInterval = setInterval(async ()=>{
            const response = await axios.post(`${this.$apiUrl}/webscan/status`,{}, { withCredentials: true });
            if(response.data.error){
              clearInterval(this.statusInterval);
              this.stopStopWatch();
              switch(res.data.error){
                case "login validation failed": this.showError("Login validation failed.");break;
                case "spider status error occur": this.showError("Login validation failed.");break;
              }
            }else{
              const {status, left, step} = response.data;
              if(left > 0){
                this.$store.commit('setCurLeft', left);
              }else{
                if(!this.stopWatchFlag){
                  this.startStopWatch();
                  this.stopWatchFlag = true;
                }
                this.$store.commit('setCurLeft', 0);
                this.value = step =='SPIDER'? Math.floor(status/2):step =='SCAN'?50+Math.floor(status/2):0;
                if(status == 100 && step == 'SCAN'){
                  console.log("scan 완료");
                  clearInterval(this.statusInterval);
                  await this.scanAlert(this.scanId);
                  this.stopStopWatch();
                }
                else if(step == 'auth failed'){
                  clearInterval(this.statusInterval);
                  this.stopStopWatch();
                  this.showError("Login validation failed.");
                }
              }
            }
          },3000);
        }
        // this.$store.dispatch("scanStart", payload);
      }catch(error){
        this.showError("An error occurred during scanning.")
        this.stopStopWatch();
        console.error(error);
      }
    },
    SpiderStatus: async function(){
      var status= 0;
      await axios.post(`${this.$apiUrl}/webscan/status`, { withCredentials: true })
      .then((res)=>{
        if(res.data.error){
          clearInterval(this.statusInterval);
          this.stopStopWatch();
          switch(res.data.error){
            case "login validation failed": this.showError("Login validation failed.");break;
            case "spider status error occur": this.showError("Login validation failed.");break;
          }
        }else{
          if(res.data.left == 0){
            this.value += res.data.status/2;
          }
        }
      }).catch((error)=>{
        console.error("spider status error:", error);
        this.stopStopWatch();
      })
      return status;
    },
    scanStart: async function(id){
      this.scanId = await axios.post(`${this.$apiUrl}/webscan/scan`, { spider_id: id }, { withCredentials: true }).then((res) => res.data.scan);
      // if(this.scanInterval) return;
      // this.scanInterval = setInterval(async () => {
      //   if (await this.scanStatus(id) == '100') {
      //       clearInterval(this.scanInterval);
      //       await this.scanAlert(id)
      //   }
      // }, 3000);
      this.scanStatus(this.scanId);
    },
    scanStatus: async function(id){
      try{
        const res = await axios.post(`${this.$apiUrl}/webscan/scan/status`, { scan_id: id }, {withCredentials: true})
        const status = res.data.status;

        if(status == '100'){
          this.value = 50 + Math.floor(res.data.status / 2);
          this.$store.commit('setScanStatus', this.value);
          await this.scanAlert(id)
        }else{
          this.value = 50 + Math.floor(res.data.status / 2);
          this.$store.commit('setScanStatus', this.value);
          setTimeout(()=>{
            this.scanStatus(id);
          }, 3000);
        }
      }catch (error){
        console.error("상태 요청 실패: ", error);
        this.stopStopWatch();
      }
      // var status = 0;
      // if(status == '100'){
        
      // }
        // .then((res) => {
        //     this.value = 50 + Math.floor(res.data.status / 2);
        //     this.$store.commit('setScanStatus', this.value);
        //     status= res.data.status;
        // })
        // .catch((error) => {
        //     console.error("Scan status error:", error);
        //     this.stopStopWatch();
        // });
        // return status;
    },
    scanAlert: async function(scanId){
      try {
        const finalArr = [];
        const response = await axios.post(`${this.$apiUrl}/webscan/scan/alerts`, { scan_id: scanId }, { withCredentials: true });
        if(Array.isArray(response.data)){
          var resultArr = response.data;
          console.log(resultArr)
          var infoObj = resultArr.pop();
          const levels = ["High", "Medium", "Low", "Informational", "Malware", "Well-Known", "owasp"];
          const dataArr = levels.map((level) =>
              Array.isArray(resultArr)
              ? resultArr.filter(
                (item) =>
                      item.risk && item.risk.toLowerCase() === level.toLowerCase()
                    )
                    : []
          );
          
          
          console.log("dataArr")
          console.log(dataArr)

          this.result=[];
          this.yaraInstance=[];

          const arr = dataArr.pop();
          
          dataArr.forEach((group) => {// risk level 별로 순회
            if (group.length) {// 해당 risk 발견된 경우
              const uniqueAlerts = []; 
              console.log("group")
              console.log(group);
  
              group.forEach((item) => {// alert 별로 분류(+인스턴스 분류)
                if(item.risk != 'Well-Known'){
                  const idx = uniqueAlerts.findIndex(obj => obj.alert == item.alert);
                  if (idx === -1) {// 새로운 alert 값인 경우
                      item.cnt = group.filter((i) => i.alert === item.alert).length;
                      item.instance = item.instance || [
                          {
                              url: item.url,
                              method: item.method || "N/A", 
                              param: item.param || "N/A",
                              attack: item.attack || "N/A",
                              description: item.description || "N/A",
                              solution: item.solution || "N/A",
                              reference: item.reference || "N/A",
                              other: item.other,
                              
                          },
                      ];
                      uniqueAlerts.push(item);
                  } else {
                      uniqueAlerts[idx].instance.push({
                      url: item.url || "N/A",
                      method: item.method || "N/A",
                      param: item.param || "N/A",
                      attack: item.attack || "N/A",
                      description: item.description || "N/A",
                      solution: item.solution || "N/A"
                      });
                      
                  }
                }else{
                    const idx = uniqueAlerts.findIndex(obj => obj.alert = item.alert);
                    if(idx == -1){
                        item.instance=[{
                        url: item.url,
                        description:item.description,
                        solution: item.solution,
                        reference: item.reference,
                        name: item.other
                        }]
                        uniqueAlerts.push(item);
                    }else{
                        uniqueAlerts[idx].instance.push({
                        url: item.url,
                        description:item.description,
                        solution: item.solution,
                        reference: item.reference,
                        name: item.other
                        })
                    }
                  }
              });
  
              console.log(group)
  
              this.yaraInstance=[];
              group.forEach((x)=>{
                  // console.log(x);
                  if(x.risk.toLowerCase() == 'malware'){
                      if(x.instance){
                          this.allMalwares = x.instance.length;
                          const validInstances=[]; 
                          const instances =[];
                          x.instance.forEach((y)=>{
                          if(y.description !== 'no search malware at Url\n'){
                              validInstances.push(y);
                          }else{
                              instances.push(y);
                          }
                          
                          })
                          x.foundInst = validInstances; 
                          x.instance = instances;
                          this.malwareCnt = validInstances.length;
                      }
                  }
                  if(x.risk == 'Well-Known'){
                    console.log("Well-KNOWN >>>>>>>>>>>>>>>")
                      const uniqueUrl = [];
                      if (!x.validInst) x.validInst = {}; 
                      if(x.instance){
                          x.instance.forEach((i)=>{
                          const idx = uniqueUrl.indexOf(i.url)
                          //인스턴스 수를 세기 위함
                          const instanceIdx = this.yaraInstance.indexOf(i.url);
                          if(instanceIdx == -1 ){
                              this.yaraInstance.push(i.url);
                          }
                          if(idx==-1){
                              uniqueUrl.push(i.url);
                              x.validInst[i.url]=[];
                              x.validInst[i.url].push(i);
                          }else{
                              x.validInst[i.url].push(i)
                          }
                          
                          })
                      }
                  }
              })
  
              finalArr.push(uniqueAlerts);
            }else{
              console.log(resultArr)
            }
          })
          finalArr.push(infoObj);
          finalArr.push(arr);
          this.result = finalArr;
          this.$store.commit('setCurResult', this.result);
          localStorage.setItem("scanResult",JSON.stringify(this.result));
          this.stopStopWatch();
        }
      }catch(error){
        console.error("Scan alert error:", error);
        this.stopStopWatch();
      }
    },
  },
  mounted() {
    EventBus.$on("start-scan", this.startScan)
    EventBus.$on("stop-scan", this.stopStopWatch)
    this.$store.commit("setTimeTaken", this.timeTaken);
    this.$store.commit("setScanStatus", undefined)
    localStorage.removeItem("timeTaken");
    localStorage.removeItem("scanStatus");
    localStorage.removeItem("scanResult");
    this.checkForInactivity();
    window.addEventListener('mousemove', this.resetInactivityTimer);
    window.addEventListener('keypress', this.resetInactivityTimer);
    window.addEventListener('click', this.resetInactivityTimer);
    window.addEventListener('beforeunload', this.handlePageUnload);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.resetInactivityTimer();
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.resetInactivityTimer);
    window.removeEventListener('keypress', this.resetInactivityTimer);
    window.removeEventListener('click', this.resetInactivityTimer);
    window.removeEventListener('beforeunload', this.handlePageUnload);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }
}
</script>

<style scoped>
.v-application--wrap{
  height: 100vh;
}
.v-main{
  background-color: #fcfcfc;
  height: 100vh;
}
.v-toolbar__content {
  height: 48px;
  position: relative;
}
#main-bar {
  left: 0 !important;
}
.home-btn {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin: 0 !important;
  min-width: auto !important;
}

.v-list-item__icon{
  margin: 10px !important;
}

</style>
